export const messages = {
    'Open existing project': 'Ouvrir un projet existant',
    'Search': 'Rechercher',
    'Name': 'Nom',
    'Date': 'Date',
    'Type': 'Type',
    'No Events yet': 'Aucun événement pour le moment',
    'No result found for': 'Aucun résultat trouvé pour',
    'Load more': 'Afficher plus de projets',
    'Running': 'En cours',
    'Opened': 'Ouvert',
    'Yesterday': 'Hier',
    'Today': 'Aujourd\'hui',
    'Tomorrow': 'Demain',
};